(function () {
  const supportedGenders = ['man', 'woman', 'unisex'];

  function normalizeGender(value) {
    const normalized = String(value || '').trim().toLowerCase();
    return supportedGenders.includes(normalized) ? normalized : '';
  }

  function selectedGender(productInfo) {
    // Gender is a browsing context, not a product variant. Collection and
    // megamenu links pass ?gender=woman|man; unisex intentionally shows all.
    const urlGender = normalizeGender(new URLSearchParams(window.location.search).get('gender'));
    if (urlGender) return urlGender;

    const genderOption = productInfo.querySelector(
      '[data-option-name="gender"], [data-option-name="genero"], [data-option-name="género"]'
    );

    if (!genderOption) return '';

    const checkedInput = genderOption.querySelector('input:checked');
    if (checkedInput) return normalizeGender(checkedInput.value);

    const select = genderOption.querySelector('select');
    return normalizeGender(select?.value);
  }

  function taggedGender(element) {
    const token = String(element.dataset.mediaGender || '').trim().toLowerCase();
    if (token === 'gender-all') return 'all';
    if (!token.startsWith('gender-')) return '';
    return normalizeGender(token.slice(7));
  }

  function updateCounters(productInfo) {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    const visibleMedia = Array.from(
      gallery.querySelectorAll('.product__media-list > [data-media-gender]')
    ).filter((item) => !item.hidden);

    gallery.querySelectorAll('.slider-counter--total').forEach((counter) => {
      counter.textContent = visibleMedia.length;
    });

    const currentCounter = gallery.querySelector('.slider-counter--current');
    if (currentCounter && Number(currentCounter.textContent) > visibleMedia.length) {
      currentCounter.textContent = visibleMedia.length ? '1' : '0';
    }
  }

  function filterGallery(productInfo) {
    if (!productInfo) return;
    const gender = selectedGender(productInfo);

    const mediaItems = Array.from(productInfo.querySelectorAll('[data-media-gender]'));
    mediaItems.forEach((media) => {
      const mediaGender = taggedGender(media);
      media.hidden = Boolean(gender && mediaGender && mediaGender !== 'all' && mediaGender !== gender);
      if (media.hidden) media.classList.remove('is-active');
    });

    if (gender) {
      const firstVisible = mediaItems.find((media) => !media.hidden);
      if (firstVisible && !mediaItems.some((media) => media.classList.contains('is-active'))) {
        firstVisible.classList.add('is-active');
      }
    }

    updateCounters(productInfo);
  }

  function filterAllGalleries() {
    document.querySelectorAll('product-info').forEach(filterGallery);
  }

  document.addEventListener('DOMContentLoaded', filterAllGalleries);
  document.addEventListener('product-info:loaded', (event) => filterGallery(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      const productInfo = data?.event?.target?.closest('product-info');
      window.requestAnimationFrame(() => filterGallery(productInfo));
    });

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      window.requestAnimationFrame(() => filterGallery(productInfo));
    });
  }
})();
